function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.478 12.848a6 6 0 111.414-1.414L15 14.54l-1.415 1.415-3.106-3.107zm.524-4.89a4 4 0 11-8 0 4 4 0 018 0z",
  fill: "#A7AEB7"
});

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40NzggMTIuODQ4M0M5LjQ5NzE4IDEzLjU0NjcgOC4yOTczIDEzLjk1NzUgNy4wMDE0NiAxMy45NTc1QzMuNjg3NzYgMTMuOTU3NSAxLjAwMTQ2IDExLjI3MTIgMS4wMDE0NiA3Ljk1NzUyQzEuMDAxNDYgNC42NDM4MSAzLjY4Nzc2IDEuOTU3NTIgNy4wMDE0NiAxLjk1NzUyQzEwLjMxNTIgMS45NTc1MiAxMy4wMDE1IDQuNjQzODEgMTMuMDAxNSA3Ljk1NzUyQzEzLjAwMTUgOS4yNTMzNSAxMi41OTA3IDEwLjQ1MzIgMTEuODkyMiAxMS40MzQxTDE0Ljk5ODYgMTQuNTQwNEwxMy41ODQ0IDE1Ljk1NDZMMTAuNDc4IDEyLjg0ODNaTTExLjAwMTUgNy45NTc1MkMxMS4wMDE1IDEwLjE2NjcgOS4yMTA2IDExLjk1NzUgNy4wMDE0NiAxMS45NTc1QzQuNzkyMzMgMTEuOTU3NSAzLjAwMTQ2IDEwLjE2NjcgMy4wMDE0NiA3Ljk1NzUyQzMuMDAxNDYgNS43NDgzOCA0Ljc5MjMzIDMuOTU3NTIgNy4wMDE0NiAzLjk1NzUyQzkuMjEwNiAzLjk1NzUyIDExLjAwMTUgNS43NDgzOCAxMS4wMDE1IDcuOTU3NTJaIiBmaWxsPSIjQTdBRUI3Ii8+Cjwvc3ZnPgo=";
export { SvgSearch as ReactComponent };